import { Layout, TaskElement as TaskElementComponent } from "components"
export const TaskElement = () => {
 return (
  <Layout>
   <TaskElementComponent />
  </Layout>
 )
}
